import { render, staticRenderFns } from "./activityJoin.vue?vue&type=template&id=13d44ccc&scoped=true&"
import script from "./activityJoin.vue?vue&type=script&lang=js&"
export * from "./activityJoin.vue?vue&type=script&lang=js&"
import style0 from "./activityJoin.vue?vue&type=style&index=0&id=13d44ccc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d44ccc",
  null
  
)

export default component.exports